import { ExclamationCircleFilled } from '@ant-design/icons';
import { Button, Modal, Typography } from 'antd';
import { observer } from 'mobx-react';
import styled from 'styled-components';

const { Text } = Typography;

const IconCircle = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #fff7e6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

const Footer = styled.div`
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 8px;
`;

interface IProps {
  open: boolean;
  loading?: boolean;
  onOk: () => void;
  onLeave: () => void;
  onCancel: () => void;
}

export const UnsavedChangesModal: React.FC<IProps> = observer(
  ({ open, loading, onOk, onLeave, onCancel }) => {
    return (
      <Modal
        open={open}
        onCancel={onCancel}
        closable={false}
        centered
        width={420}
        footer={null}
      >
        <div style={{ textAlign: 'center', padding: '8px 0 4px' }}>
          <div style={{ display: 'inline-flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
            <IconCircle>
              <ExclamationCircleFilled style={{ fontSize: 22, color: '#faad14' }} />
            </IconCircle>
            <Text strong style={{ fontSize: 16 }}>
              Unsaved changes
            </Text>
          </div>
          <div>
            <Text style={{ color: '#888', fontSize: 14 }}>
              You have unsaved changes that will be lost if you leave
            </Text>
          </div>
        </div>

        <Footer>
          <Button onClick={onCancel} disabled={loading}>
            Stay
          </Button>
          <Button danger onClick={onLeave} disabled={loading}>
            Discard & close
          </Button>
          <Button type="primary" onClick={onOk} loading={loading}>
            Save & close
          </Button>
        </Footer>
      </Modal>
    );
  }
);
